import { EventEmitter } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../services/index';
import { JWT } from '../helpers';
import { DASHBOARDENDPOINTS } from '../environment';
import './../rxjs-operators';
var DashboardService = /** @class */ (function () {
    function DashboardService(http, route, router, alertService) {
        this.http = http;
        this.route = route;
        this.router = router;
        this.alertService = alertService;
        this.apiurl = '';
        this.apiurlV2 = '';
        this.notificationApiUrl = '';
        this.userdata = {};
        this.userEvent = new EventEmitter();
        this.apiurl = process.env.API_URL;
        this.apiurlV2 = process.env.API_URLV2;
        this.notificationApiUrl = process.env.NOTIFICATION_API_URL;
        if (this.notificationApiUrl == '' || this.notificationApiUrl == undefined || this.notificationApiUrl == null) {
            this.notificationApiUrl = this.apiurl;
        }
    }
    DashboardService.prototype.loggedInUserDataForWebsocket = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.userSummary, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.userSummary = function () {
        var _this = this;
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.userSummary, JWT.jwt()).map(function (response) { return response.json(); }).subscribe(function (data) {
            _this.userdata = data;
        });
    };
    DashboardService.prototype.loggedInUser = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.loggedInUser, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.pollLoggedInUser = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollLoggedInUser, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.country = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.country, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.filterState = function (countryid, queryState) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.filterState + countryid + '?queryState=' + queryState, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.filterCity = function (stateid, queryCity) {
        console.log(stateid);
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.filterCity + stateid + '?queryCity=' + queryCity, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.logOff = function () {
        console.log("The Auth Header in localstorage in dashbord service==>" + localStorage.getItem('authorization'));
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.logOff, {}, JWT.jwt()).map(function (response) { return response; });
    };
    DashboardService.prototype.pollSessionExpiryCheck = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollSessionExpiryCheck, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.userSummary1 = function () {
        var _this = this;
        var res = this.http.get(this.apiurl + DASHBOARDENDPOINTS.userSummary1, JWT.jwt()).map(function (response) { return response.json(); });
        res.subscribe(function (data) {
            _this.userdata = data;
        });
        return res;
    };
    DashboardService.prototype.topSearchget = function (key) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.topSearchget + key, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.profileVisits = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.profileVisits, JWT.jwt()).map(function (response) { return response.json(); });
    };
    /*    allProfileVisits() {
            return this.http.get(this.apiurl+DASHBOARDENDPOINTS.allProfileVisits, JWT.jwt()).map((response: Response) => response.json());
        }

        allProfileVisitsLoadMore() {
            return this.http.get(this.apiurl+DASHBOARDENDPOINTS.allProfileVisitsLoadMore, JWT.jwt()).map((response: Response) => response.json());
        }*/
    DashboardService.prototype.pollProfileVisits = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollProfileVisits, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.profileVisitsbyId = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.profileVisitsbyId + id + '/', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.profilePercentage = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.profilePercentage, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.profileVisitsCoursebyMeId = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.profileVisitsCoursebyMeId + id + '/', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.topCourses = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.topCourses, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.pollTopCourses = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollTopCourses, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.suggestFriends = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.suggestFriends, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.pollSuggestFriends = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollSuggestFriends, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.hotTopics = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.hotTopics, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.pollHotTopics = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollHotTopics, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.topicSpam = function (type, id) {
        if (type == "reply") {
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.spamTopicCommentReply + "/" + id + "/spam", {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
        else {
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.spamTopicComment + "/" + id + "/spam", {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
    };
    DashboardService.prototype.inboxSpam = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.spamInboxReply + "/" + id + "/spam", {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.hotJobs = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.hotJobs, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.pollHotJobs = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollHotJobs, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.updateUserProfileType = function (profileData) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.updateUserProfileType, profileData, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.sendInvitationReq = function (user) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.sendInvitationReq, user, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.networkUpdates = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.networkUpdates, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.pollNetworkUpdates = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.pollNetworkUpdates, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.networkUpdatesLoadMore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.networkUpdatesLoadMore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.viewProfile = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.viewProfile, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.editviewProfile = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.editviewProfile, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.searchUser = function (User) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.searchUser, User, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addCoHost = function (coHost) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.addCoHost, coHost, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addSpeaker = function (speaker) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.addSpeaker, speaker, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.removeCoHost = function (coHost) {
        return this.http.delete(this.apiurl + DASHBOARDENDPOINTS.addCoHost, JWT.jwtDelete(coHost)).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.removeSpeaker = function (speaker) {
        return this.http.delete(this.apiurl + DASHBOARDENDPOINTS.addSpeaker, JWT.jwtDelete(speaker)).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.searchUserLoadMore = function (User) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.searchUser + '?loadMore=true', User, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.educationalQualification = function (educationalQualification) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.educationalQualification, educationalQualification, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.updateUserProfileTypeAndEducationalQualification = function (educationalQualification) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.updateUserProfileTypeAndEducationalQualification, educationalQualification, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.degreeCourse = function (educationalQualification) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.degreeCourse, educationalQualification, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.linkedInProfile = function (linkedInProfile) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.linkedInProfile, linkedInProfile, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getpastEducation = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getpastEducation, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addpastEducation = function (pastEducation) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.addpastEducation, pastEducation, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.updatepastEducation = function (pastEdudata) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.updatepastEducation, pastEdudata, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.deletepastEducation = function (pastEducation) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.deletepastEducation, pastEducation, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.editAboutMe = function (editAboutMe) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.editAboutMe, editAboutMe, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addSkills = function (pastEducation) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.addSkills, pastEducation, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getSkills = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getSkills, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addWorkExp = function (workExp) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.addWorkExp, workExp, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getWorkExp = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getWorkExp, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.coursesIRcmd = function (key) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.coursesIRcmd + key, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.updateCiRcmd = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.updateCiRcmd, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getCiRcmd = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getCiRcmd, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.updateWorkExp = function (workExp) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.updateWorkExp, workExp, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.deleteWorkExp = function (workExp) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.deleteWorkExp, workExp, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.uploadImage = function (img) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.uploadImage, img, JWT.jwtImg()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.userAccptRcmd = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.userAccptRcmd, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.updateuserAccptRcmd = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.updateuserAccptRcmd, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myInterest = function (myInterest) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myInterest, myInterest, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.viewcourseByMe = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.viewcourseByMe, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.editcourseByMe = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.editcourseByMe, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getMyconnections = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getMyconnectionsLoadMore = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections + '?loadMore=true', data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myConnections = function (data) {
        data.baseSearchActionType = "IN_MY_NETWORK";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addConnections = function (data) {
        data.baseSearchActionType = "INTERESTED_CONNECTIONS";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myConnectionsLoadMore = function (data) {
        data.baseSearchActionType = "IN_MY_NETWORK";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections + '?loadMore=true', data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addConnectionsLoadMore = function (data) {
        data.baseSearchActionType = "INTERESTED_CONNECTIONS";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections + '?loadMore=true', data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.allProfileVisits = function (data) {
        data.baseSearchActionType = "PROFILE_VISITS";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.allProfileVisitsLoadMore = function (data) {
        data.baseSearchActionType = "PROFILE_VISITS";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections + '?loadMore=true', data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.connAccept = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.connAccept + id, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.campusConnections = function (data) {
        data.baseSearchActionType = "CAMPUS_CONNECTIONS";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.campusConnectionsLoadMore = function (data) {
        data.baseSearchActionType = "CAMPUS_CONNECTIONS";
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myConnections + '?loadMore=true', data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseReq = function (skilldata) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseReq, skilldata, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.rcmdRequest = function (reqData) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.rcmdRequest, reqData, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.rateRequest = function (reqData) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.rateRequest, reqData, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxrcmdRequest = function (reqData) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.inboxrcmdRequest, reqData, JWT.jwt()).map(function (response) { return response.ok; });
    };
    DashboardService.prototype.rcmdAccept = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.rcmdAccept + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.rcmdReject = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.rcmdReject + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.reqAccept = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.reqAccept + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.topicreqAccept = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.topicreqAccept + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.topicreqReject = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.topicreqReject + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.reqReject = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.reqReject + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.rating = function (ratingData) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.rating, ratingData, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.inboxSendMsg = function (message) {
        message.senderUserId = this.userdata.userDetailsId;
        message.htmlFormattedMessageBody = null;
        message.isMessageBodyHTMLFormatted = false;
        message.usersInCc = null,
            console.log(message);
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.inboxSendMsg, message, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.replyToMsg = function (message) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.replyToMsg, message, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxReqRecv = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxReqRecv, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getDoc = function (courseId) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.courseDocUpload + "?courseId=" + courseId, JWT.jwtDoc()).map(function (response) { return response; });
    };
    DashboardService.prototype.inboxReqRecvloadmore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxReqRecvloadmore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxRcmdRecv = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxRcmdRecv, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxRcmdRecvLoadMore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxRcmdRecvLoadMore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxReqSent = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxReqSent, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxRcmdRespSent = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxRcmdRespSent, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxMessageSent = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxMessageSent, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxReqSentLoadMore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxReqSentLoadMore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxRcmdRespSentLoadMore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxRcmdRespSentLoadMore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxMessageSentLoadMore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxMessageSentLoadMore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxAllMsg = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxAllMsg, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxMsgForContainerId = function (containerId) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxMsgForContainerId + containerId + '/', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxMsgCon = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxMsgCon + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxAllMsgLoadMore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxAllMsgLoadMore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxDelete = function (type, id) {
        var userInterActionId;
        var isRequest;
        var isResponse;
        var isSentItem;
        var isInboxItem;
        var messageContainerEntryId;
        var trashEntryId;
        if (type == "reqRec") {
            userInterActionId = id;
            isRequest = true;
            isResponse = false;
            isSentItem = false;
            isInboxItem = true;
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.reqRecDelete + userInterActionId + '/' + isRequest + '/' + isResponse + '/' + isSentItem + '/' + isInboxItem + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
        else if (type == "rcmdRec") {
            userInterActionId = id;
            isRequest = false;
            isResponse = true;
            isSentItem = false;
            isInboxItem = true;
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.rcmdRecDelete + userInterActionId + '/' + isRequest + '/' + isResponse + '/' + isSentItem + '/' + isInboxItem + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
        else if (type == "msgRec") {
            messageContainerEntryId = id;
            isInboxItem = true;
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.msgRecDelete + messageContainerEntryId + '/' + isInboxItem + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
        else if (type == "reqSent") {
            userInterActionId = id;
            isRequest = true;
            isResponse = false;
            isSentItem = true;
            isInboxItem = false;
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.reqSentDelete + userInterActionId + '/' + isRequest + '/' + isResponse + '/' + isSentItem + '/' + isInboxItem + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
        else if (type == "rcmdSent") {
            userInterActionId = id;
            isRequest = false;
            isResponse = true;
            isSentItem = true;
            isInboxItem = false;
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.rcmdSentDelete + userInterActionId + '/' + isRequest + '/' + isResponse + '/' + isSentItem + '/' + isInboxItem + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
        else if (type == "msgSent") {
            messageContainerEntryId = id;
            isInboxItem = false;
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.msgSentDelete + messageContainerEntryId + '/' + isInboxItem + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
        else if (type == "trash") {
            trashEntryId = id;
            return this.http.post(this.apiurl + DASHBOARDENDPOINTS.trashDelete + trashEntryId + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
        }
    };
    DashboardService.prototype.inboxTrash = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxTrash, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxTrashloadmore = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.inboxTrashloadmore, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inboxTrashRestore = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.inboxTrashRestore + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.userTo = function (name) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.userTo + name, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myFriendsLookup = function (friendName) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.myFriendsLookup + friendName, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.renameRecording = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.renameRecording, data, JWT.jwt()).map(function (response) { return response.toString(); });
    };
    DashboardService.prototype.topicList = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.topicList, JWT.jwt()).map(function (response) {
            var apiResponse = response.json();
            apiResponse.callName = 'topicList';
            return apiResponse;
        });
    };
    DashboardService.prototype.topicDashboard = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.topicDashboard, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.moretopicList = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.moretopicList, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.moretopicSearch = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.moretopicSearch, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.searchTopicList = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.searchTopicList, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.allJobs = function (filter) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.allJobs, filter, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.allJobsLoad = function (filter) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.jobFilter, filter, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getJob = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.allJobsLoad + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.postNewJob = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.postNewJob, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.uploadTopicImage = function (img) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.uploadTopicImage, img, JWT.jwtImg()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.createTopic = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.createTopic, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.topicPermissionType = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.topicPermissions, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.topicTypes = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.allTopicTypes, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getTopic = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getTopic + id + '?isTopicSubscriberOnly=false', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getTopicSubs = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getTopic + id + '?isTopicSubscriberOnly=true', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.removeSubscriber = function (topicId, subId) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.removeTopicSubscriber + subId + '/' + topicId, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.joinTopic = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.joinTopic + id + '/', {}, JWT.jwt()).map(function (response) { return response.toString(); });
    };
    DashboardService.prototype.leaveTopic = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.leaveTopic + id + '/', {}, JWT.jwt()).map(function (response) { return response.toString(); });
    };
    DashboardService.prototype.closeTopic = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.closeTopic + id + '/', {}, JWT.jwt()).map(function (response) { return response.toString(); });
    };
    DashboardService.prototype.addComment = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.createTopicComment + data.topicDetailId, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addInnerComment = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.replyTopicComment + data.topicDetailId + '/' + data.topicCommentId, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.likeTopic = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.likeTopic + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.unlikeTopic = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.unlikeTopic + id + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myTopics = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.myTopics, JWT.jwt()).map(function (response) {
            var myTopicsResponse = response.json();
            myTopicsResponse.topicInitializationType = 'MYTOPICS';
            return myTopicsResponse;
        });
    };
    DashboardService.prototype.loadmoremyTopics = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.myTopicsLoadMore, JWT.jwt()).map(function (response) {
            try {
                return response.json();
            }
            catch (err) {
                return [];
            }
        });
    };
    DashboardService.prototype.loadmorejoinTopics = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.myTopicsSubscriberLoadMore, JWT.jwt()).map(function (response) {
            try {
                return response.json();
            }
            catch (err) {
                return [];
            }
        });
    };
    DashboardService.prototype.myJoinTopics = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.myTopicsSubscriber, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseMetaData = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.courseMetaData, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseStaticMetaData = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.courseStaticMetaData, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseImageUpload = function (file) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseImageUpload, file, JWT.jwtImg()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.courseDocUpload = function (file) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseDocUpload, file, JWT.jwtImg()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.createCourse = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.course, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.editCourse = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.editCourse, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.deriveCourseScheduledEndDate = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseScheduledEndDate, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.retrieveCourseScheduleSummary = function (repeatType, repeatEvery, weeklyRepeatDays) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.courseScheduleSummary +
            "?repeatType=" + repeatType + "&repeatEvery=" + repeatEvery + "&weeklyRepeatDays=" + weeklyRepeatDays, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.onlineCourses = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.course, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.onlineCoursesLite = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.courseLite, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseCancle = function (id) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.refund + id, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.refundSearch = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.refundSearch, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.refundInit = function (cId, aId) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.refundInit + cId + '/' + aId, {}, JWT.jwt()).map(function (response) { return response.toString(); });
    };
    DashboardService.prototype.canScheduleFreeCourse = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.canScheduleFree, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.openCourses = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.openCourses, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.openCoursesFilters = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.openCoursesFilters, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getCourse = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.course + id + '/', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getAttendees = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.courseAttendee + id + '/attendees', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.searchAttendees = function (text) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.searchAttendees, text, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseNameAutocomplate = function (word) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseNameAutocomplate + word + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseownerNameAutocomplate = function (word) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseownerNameAutocomplate + word + '/', {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.enrolledCourse = function () {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.enrolledCourse, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.enrolledCourseReview = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.enrolledCourseReview, data, JWT.jwt()).map(function (response) { return response.toString(); });
    };
    DashboardService.prototype.searchCourse = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.searchCourse, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseConnections = function (key) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.courseConnections, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseInvite = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseInvite, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseNotification = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseNotification, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.payoutCourse = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.payoutCourse + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseadmin = function () {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseAdmin, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseadminsearch = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseAdmin, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseadminapprove = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseAction, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.courseadminreject = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.courseAction, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.registerPaypal = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.registerPaypal + data, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.registerQuestionnairePaypal = function (data, questionnaire) {
        return this.http.post(this.apiurlV2 + DASHBOARDENDPOINTS.paidQuestionnaireRegister + data, questionnaire, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.registerCC = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.registerCC, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.registerCourseFree = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.registerCourseFree + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.applyCoupon = function (code, id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.applyCoupon + "?couponCode=" + code + "&sessionId=" + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.deleteCouponCode = function (couponId) {
        return this.http.delete(this.apiurl + DASHBOARDENDPOINTS.addCoupon + couponId, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addCouponCode = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.addCoupon, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myAccountDetails = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.myAccountDetails, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.payoutList = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.payoutList, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.makePayout = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.makePayout + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.makeManualPayout = function (reqid, refid) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.makeManualPayout + reqid + "?paymentReferenceNo=" + refid, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.userAccountStatus = function (userId) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.userAccountStatus + userId + '/', JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.deleteAccount = function (deleteAccountVerificationPassword) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.deleteAccount, deleteAccountVerificationPassword, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.deleteAccountOTP = function () {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.deleteAccountOTP, {}, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.myAccountDetailsUpdate = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myAccountDetailsUpdate, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myAccountDetailsUpdateEmail = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myAccountDetailsUpdateEmail, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myAccountDetailsUpdatePass = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myAccountDetailsUpdatePass, data, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.myAccountPaypal = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myAccountPaypal, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myAccountPaypalUpdate = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myAccountPaypalUpdate, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.myAccountPaypalDeactivate = function () {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.myAccountPaypalDeactivate, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.gmailUsersCheck = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.gmailUsersCheck, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.gmailContacts = function () {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.gmailContacts, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.gmailNextContacts = function (contactsInPage) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.gmailNextContacts, contactsInPage, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.gmailPrevContacts = function (contactsInPage) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.gmailPrevContacts, contactsInPage, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.gmailInviteSent = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.gmailInviteSent, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.billingPlans = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.billingPlans, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addNewPlan = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.billingPlans, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.upgradePlansall = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.upgradePlansall, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.upgradePlanCC = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.upgradePlanCC, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.upgradePlanPaypal = function (data) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.upgradePlanPaypal, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.inviteEmail = function (email) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.inviteEmail, email, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.sendRecommendationForRequest = function (reqData, recommendationRequestId) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.sendRecommendationForRequest + recommendationRequestId, reqData, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.sendRatingForRequest = function (reqData, ratingRequestId) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.sendRatingForRequest + ratingRequestId, reqData, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.ignoreNotification = function (userId, event, notificationItemBusinessKey) {
        console.log('his.notificationApiUrl==>' + this.notificationApiUrl);
        return this.http.post(this.notificationApiUrl + DASHBOARDENDPOINTS.ignoreNotification
            + "/" + userId + "/" + event + "/" + notificationItemBusinessKey, {}, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.markNotificationRead = function (userId, event, notificationItemBusinessKey) {
        return this.http.post(this.notificationApiUrl + DASHBOARDENDPOINTS.ignoreNotification
            + "/" + userId + "/" + event + "/" + notificationItemBusinessKey, {}, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.meetingReqAccept = function (meetingAcceptReqData) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.meetingReqAcceptReject, meetingAcceptReqData, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.meetingReqReject = function (meetingRejectReqData) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.meetingReqAcceptReject, meetingRejectReqData, JWT.jwt()).map(function (response) { return response.text(); });
    };
    DashboardService.prototype.getPaymentDetails = function () {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getPaymentDetails, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.addQuestionnaire = function (questionnaire) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.addQuestionnaire, questionnaire, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.updateQuestionnaire = function (questionnaire) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.updateQuestionnaire, questionnaire, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getQuestionnaire = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getQuestionnaire + "/" + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.deleteQuestionnaire = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.deleteQuestionnaire + "/" + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getSessionQuestionnaire = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getSessionQuestionnaire + "/" + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getQuestionnaireAns = function (id, userId) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getAnswerQuestionnaire + "/" + userId + "/" + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.getQuestionnaireAll = function (id) {
        return this.http.get(this.apiurl + DASHBOARDENDPOINTS.getAnswerQuestionnaire + "/all/" + id, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.registerQuestionnaireCourseFree = function (id, data) {
        return this.http.post(this.apiurlV2 + DASHBOARDENDPOINTS.registerCourseFree + id, data, JWT.jwt()).map(function (response) { return response.json(); });
    };
    DashboardService.prototype.registrationPossible = function (id, status) {
        return this.http.post(this.apiurl + DASHBOARDENDPOINTS.registrationPossible + "/" + id + "/" + status, {}, JWT.jwt()).map(function (response) { return response.json(); });
    };
    return DashboardService;
}());
export { DashboardService };
//# sourceMappingURL=dashboard.service.js.map